/**
 * Copyright (c) 2023 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : locale_en.jsx
 * description   : {{insert here}}
 * creation date : 11/11/2023
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    locale_msg,
} from '@/utils/locale/enums';



// --------------------------------------------------------------------------------
//      CONSTANTS DEFINITION
// --------------------------------------------------------------------------------

const en_US =
{
    [locale_msg.COGNITO_AUTH__SIGN_IN__HEADER]: 'Sign in to your account',
    [locale_msg.COGNITO_AUTH__SIGN_IN__TAB]: 'Sign in',
    [locale_msg.COGNITO_AUTH__SIGN_IN__BUTTON]: 'Sign in',
    [locale_msg.COGNITO_AUTH__SIGN_IN__TRY]: 'Signing in',
    [locale_msg.COGNITO_AUTH__SIGN_IN__RESET_PASSWORD]: 'Reset password',

    [locale_msg.COGNITO_AUTH__CREATE_ACCOUNT__HEADER]: 'Create a new account',
    [locale_msg.COGNITO_AUTH__CREATE_ACCOUNT__TAB_AND_BUTTON]: 'Create account',
    [locale_msg.COGNITO_AUTH__CREATE_ACCOUNT__TRY]: 'Creating account',
    [locale_msg.COGNITO_AUTH__CREATE_ACCOUNT__BACK_TO_SIGN_IN]: 'Back to sign in',

    [locale_msg.COGNITO_AUTH__CONFIRM_CREATE_ACCOUNT__HEADER]: 'Confirmation code',
    [locale_msg.COGNITO_AUTH__CONFIRM_CREATE_ACCOUNT__CONFIRM]: 'Confirm',
    [locale_msg.COGNITO_AUTH__CONFIRM_CREATE_ACCOUNT__CONFIRMING]: 'Confirming',
    [locale_msg.COGNITO_AUTH__CONFIRM_CREATE_ACCOUNT__RESEND_CODE]: 'Resend code',

    [locale_msg.COGNITO_AUTH__RESET_PASSWORD__HEADER]: 'Reset password',
    [locale_msg.COGNITO_AUTH__RESET_PASSWORD__SEND_CODE]: 'Send code',
    [locale_msg.COGNITO_AUTH__RESET_PASSWORD__SENDING]: 'Sending',
    [locale_msg.COGNITO_AUTH__RESET_PASSWORD__BACK_TO_SIGN_IN]: 'Back to sign in',

    [locale_msg.COGNITO_AUTH__CONFIRM_RESET_PASSWORD__HEADER]: 'Reset password',
    [locale_msg.COGNITO_AUTH__CONFIRM_RESET_PASSWORD__SUBMIT]: 'Submit',
    [locale_msg.COGNITO_AUTH__CONFIRM_RESET_PASSWORD__SUBMITTING]: 'Submitting',

    [locale_msg.COGNITO_AUTH__FORCE_NEW_PASSWORD__HEADER]: 'Reset password',
    [locale_msg.COGNITO_AUTH__FORCE_NEW_PASSWORD__CHANGE_PASSWORD]: 'Submit',
    [locale_msg.COGNITO_AUTH__FORCE_NEW_PASSWORD__CHANGING]: 'Changing',

    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__HEADER]: 'Verify e-mail',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__VERIFY]: 'Verify',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__VERIFYING]: 'Verifying',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__SKIP]: 'Skip',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__EMAIL]: 'E-mail',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__CODE]: 'Code',

    [locale_msg.COGNITO_AUTH__CONFIRM_VALIDATE_PASSWORD__HEADER]: 'Verify e-mail',

    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__EMAIL]: 'E-mail:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__NAME]: 'Name:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__FAMILY_NAME]: 'Family name:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__NICKNAME]: 'Company:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__PHONE_NUMBER]: 'Phone number:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__PASSWORD]: 'Password:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__CONFIRM_PASSWORD]: 'Confirm password:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__CONFIRMATION_CODE]: 'Confirmation code:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__NEW_PASSWORD]: 'New password:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__CONFIRM_NEW_PASSWORD]: 'Confirm password:',

    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__EMAIL]: 'Enter your e-mail',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__NAME]: 'Enter your name',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__FAMILY_NAME]: 'Enter your family name',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__NICKNAME]: 'Enter your company name',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__PHONE_NUMBER]: 'Enter your phone number',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__PASSWORD]: 'Enter your password',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__CONFIRM_PASSWORD]: 'Please confirm your password',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__CONFIRMATION_CODE]: 'Enter your confirmation code',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__NEW_PASSWORD]: 'Enter your new password',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__CONFIRM_NEW_PASSWORD]: 'Confirm your new password',

    [locale_msg.GENERAL__COPYRIGHT]: 'All rights reserved',
    [locale_msg.GENERAL__LOG_IN]: 'Log in',
    [locale_msg.GENERAL__LOG_OUT]: 'Log out',
};



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export {
    en_US,
};



// End of file
